module.exports = __webpack_public_path__ + "static/media/float_schemes_directly.8c4d2261.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/float_schemes_directly.svg
// module id = 171
// module chunks = 0